import groupTeamIcon from "../images/group-team-icon.svg";

export const GROUP_CHAT_CONTEXT_TYPE = "GROUP";
export const GROUP_CHAT_AVATAR_ALT = "Group chat avatar";

export const isGroupChatConversation = (chat) => (
    chat?.contextType === GROUP_CHAT_CONTEXT_TYPE
);

export const resolveChatAvatarProps = (chat) => {
    if (isGroupChatConversation(chat)) {
        return {
            userId: undefined,
            avatarUrl: undefined,
            resolvedAvatar: {
                avatarUrl: groupTeamIcon,
                shouldUseSupportAvatar: false,
            },
            fallbackSrc: groupTeamIcon,
            enableProfilePreview: false,
        };
    }

    return {
        userId: chat?.avatarUserId,
        avatarUrl: chat?.avatarUrl || undefined,
        resolvedAvatar: undefined,
        fallbackSrc: undefined,
        enableProfilePreview: true,
    };
};

export const resolveChatAvatarAlt = (chat, fallbackAlt = "User avatar") => (
    isGroupChatConversation(chat) ? GROUP_CHAT_AVATAR_ALT : (chat?.username || fallbackAlt)
);
